var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var SubMenuIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 42,
    glyphHeight: 36
  }), React.createElement("path", {
    d: "M41.4277 14.5936H0.366821V21.4086H41.4277V14.5936Z"
  }), React.createElement("path", {
    d: "M41.4282 0.962585H0.36731V7.77767H41.4282V0.962585Z"
  }), React.createElement("path", {
    d: "M41.4277 28.2231H0.366821V35.0382H41.4277V28.2231Z"
  }));
};
export var SubMenuIconGlyph = function (props) {
  return React.createElement(SubMenuIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};